const montoAsiento = item => Number(item.monto ?? item.total ?? (Number(item.montoAbono || item.debe || 0) + Number(item.montoCargo || item.haber || 0)))

const agruparLinkagePorFechaGlosa = linkage => {
  const grupos = new Map()
  linkage.forEach(item => {
    const fecha = typeof item?.fecha === 'string' ? item.fecha.split('T')[0] : ''
    const glosa = String(item?.descripcion ?? item?.glosa ?? '').trim()
    if (!fecha || !glosa || item?.monto == null || item.monto === '') return
    const monto = Number(item.monto)
    if (!Number.isFinite(monto)) return
    const clave = JSON.stringify([fecha, glosa])
    if (!grupos.has(clave)) grupos.set(clave, { fecha, glosa, montos: [], representante: { descripcion: item.descripcion ?? item.glosa, monto: item.monto, idCuota: item.idCuota, idPrincipal: item.idPrincipal } })
    grupos.get(clave).montos.push(monto)
  })

  return [...grupos.values()]
    // Una cuota contiene exactamente los tres componentes, en el orden recibido.
    .filter(grupo => grupo.montos.length === 3)
    .map(({ fecha, glosa, representante, montos: [capital, interes, otrosCargos] }) => ({
      fecha, glosa, capital, interes, otrosCargos, representante
    }))
    .sort((a, b) => a.fecha.localeCompare(b.fecha))
}

const agruparLinkage = linkage => {
  const esCuotaDesglosada = item => item?.monto != null && (
    Object.prototype.hasOwnProperty.call(item, 'interes') ||
    Object.prototype.hasOwnProperty.call(item, 'cargo')
  )
  const desglosadas = linkage.filter(esCuotaDesglosada)
  if (desglosadas.length) {
    const cuotas = desglosadas.map(item => {
      const total = Number(item.monto)
      const interes = Number(item.interes ?? 0)
      const otrosCargos = Number(item.cargo ?? 0)
      return {
        fecha: item.fecha?.split('T')[0] || '',
        glosa: item.descripcion ?? item.glosa ?? '',
        capital: total - interes - otrosCargos,
        interes,
        otrosCargos,
        total,
        representante: { ...item }
      }
    })
    return [...cuotas, ...agruparLinkage(linkage.filter(item => !esCuotaDesglosada(item)))]
      .sort((a, b) => String(a.fecha || '').localeCompare(String(b.fecha || '')))
  }
  if (linkage.some(item => item?.monto != null)) return agruparLinkagePorFechaGlosa(linkage)
  const grupos = new Map()
  const sinComprobante = []
  const vistos = new Set()
  const campos = { 0: 'capital', 2: 'interes', 4: 'otrosCargos' }

  linkage.forEach(item => {
    const comprobante = String(item.codeComprobante || '').match(/^(.*)-(\d+)$/)
    if (!comprobante) {
      sinComprobante.push(item)
      return
    }
    const [, base, sufijo] = comprobante
    const campo = campos[sufijo]
    // Solo estos asientos describen los componentes de la cuota.
    if (!campo) return
    const fecha = item.fecha ? item.fecha.split('T')[0] : ''
    const clave = JSON.stringify([fecha, base])
    const monto = montoAsiento(item)
    const glosa = (item.glosa || '').trim()
    const identidad = JSON.stringify([clave, sufijo, monto, glosa])
    if (vistos.has(identidad)) return
    vistos.add(identidad)

    if (!grupos.has(clave)) {
      grupos.set(clave, { fecha, capital: '', interes: 0, otrosCargos: 0, glosa: '' })
    }
    const cuota = grupos.get(clave)
    cuota[campo] = Number(cuota[campo] || 0) + monto
    if (glosa && !cuota.glosa.split(' / ').includes(glosa)) {
      cuota.glosa = cuota.glosa ? `${cuota.glosa} / ${glosa}` : glosa
    }
  })

  return [...grupos.values(), ...sinComprobante].sort((a, b) => String(a.fecha || '').localeCompare(String(b.fecha || '')))
}

export const cargarCuotasPrestamo = (data, incluirRepresentante = false) => {
  const cuotas = Array.isArray(data.prestamoCuotas) ? data.prestamoCuotas : agruparLinkage(data.linkage || [])
  if (!cuotas.length) return [{ fecha: '', capital: '', interes: '', otrosCargos: '', glosa: '', total: 0 }]
  return cuotas.map(item => {
    const capital = item.capital ?? ''
    const interes = item.interes ?? ''
    const otrosCargos = item.otrosCargos ?? 0
    return {
      ...(incluirRepresentante ? { representante: item.representante } : {}),
      fecha: item.fecha ? item.fecha.split('T')[0] : '',
      capital,
      interes,
      otrosCargos,
      glosa: item.glosa || '',
      // Los registros antiguos pueden traer solamente el total, sin desglose.
      total: item.total != null ? Number(item.total) : capital !== ''
        ? Number(capital) + Number(interes || 0) + Number(otrosCargos)
        : montoAsiento(item)
    }
  })
}
